<div class="dialog-header">
  <span class="spacer"></span>
  <label class="header-label">{{'History for ' + entityId}}</label>
  <span class="spacer"></span>
  <button class="close-dialog-button warn-button" matButton="elevated" (click)="close()">X</button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{errorMessage()}}
  </div>
}
<div class="content">
  <div class="data-wrapper">
    <div class="data-row">
      <label class="data-label">Date Created:</label>
      <label class="value-label">{{entityHistory()?.createDate | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">SFR Submitted:</label>
      <label class="value-label">{{entityHistory()?.sfrSent | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">SFR Approved:</label>
      <label class="value-label">{{entityHistory()?.sfrApprove | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">FPA Submitted:</label>
      <label class="value-label">{{entityHistory()?.fpaSubmitted | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">FPA Approved:</label>
      <label class="value-label">{{entityHistory()?.fpaApproved | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">FPA Applied:</label>
      <label class="value-label">{{entityHistory()?.fpaApplied | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Sent For Review:</label>
      <label class="value-label">{{entityHistory()?.review | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Approved:</label>
      <label class="value-label">{{entityHistory()?.approve | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Released:</label>
      <label class="value-label">{{entityHistory()?.release | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Scheduled:</label>
      <label class="value-label">{{entityHistory()?.scheduleComplete | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Reviewed by Purchasing:</label>
      <label class="value-label">{{entityHistory()?.purchasingTaskComplete | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Acknowledgment Sent:</label>
      <label class="value-label">{{entityHistory()?.acknowledgeSent | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Acknowledgment Approved:</label>
      <label class="value-label">{{entityHistory()?.acknowledgeApproved | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Engineering Started:</label>
      <label class="value-label">{{entityHistory()?.engineeringStart | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Engineering Completed:</label>
      <label class="value-label">{{entityHistory()?.engineeringComplete | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
    <div class="data-row">
      <label class="data-label">Transferred to ERP:</label>
      <label class="value-label">{{entityHistory()?.transferToPrms | date: 'MM/dd/yyyy hh:mm:ss a'}}</label>
    </div>
  </div>
</div>
